const NAME_SPLIT_PATTERN = /\s*(?:\band\/or\b|\band\b|\bor\b|,|;|\r?\n|\/|\\|\||&|\+)\s*/i;

export const toBirthdayTitleCase = (value = '') => (
  String(value)
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/[A-Za-z][A-Za-z']*/g, (word) => {
      if (/^[A-Z0-9]+$/.test(word)) {
        return word;
      }

      return word
        .toLowerCase()
        .split("'")
        .map((part, index) => {
          if (!part) return part;
          if (index > 0 && part === 's') return part;
          return part.charAt(0).toUpperCase() + part.slice(1);
        })
        .join("'");
    })
    .replace(/\b(\d+)(St|Nd|Rd|Th)\b/g, (_, number, suffix) => `${number}${suffix.toLowerCase()}`)
);

export const parseBirthdayNameList = (value = '') => {
  const seen = new Set();

  return String(value)
    .replace(/\betc\.?/gi, '')
    .split(NAME_SPLIT_PATTERN)
    .map((name) => name.replace(/^[.\s]+|[.\s]+$/g, ''))
    .map(toBirthdayTitleCase)
    .filter(Boolean)
    .filter((name) => {
      const key = name.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, 10);
};

export const formatBirthdayNameInput = (value = '') => (
  parseBirthdayNameList(value).join(', ')
);
